/* eslint-disable no-unused-vars */
import { useRef, useState } from 'react'
import { Usuario } from '../../model/Usuario'

type EditProps = {
    salvar(user: Usuario): void
    cancelar(): void
    usuario: Usuario
}

const EditUser = ({ salvar, cancelar, usuario }: EditProps) => {
    const [user, setUsuario] = useState<Usuario>({ ...usuario, password: '' })

    const form = useRef<HTMLFormElement>(null)

    const onSubmit = (event: any) => {
        event.preventDefault()
        if (form?.current?.checkValidity() !== false) {
            salvar(user)
        }
        form?.current?.classList.add('was-validated')
    }

    const cancelForm = (event: any) => {
        event.preventDefault()
        setUsuario({ ...usuario, password: '' })
        form.current?.classList.remove('was-validated')
        cancelar()
    }

    function set(type: string, value: string) {
        switch (type) {
        case 'firstName':
            setUsuario({ ...user, firstName: value })
            break
        case 'email':
            setUsuario({ ...user, email: value })
            break
        case 'lastName':
            setUsuario({ ...user, lastName: value })
            break
        case 'password':
            setUsuario({ ...user, password: value })
            break
        default:
        }
    }

    return (
        <form noValidate onSubmit={onSubmit} ref={form}>
            <div className="form-row">
                <div className="col-md-4 mb-3">
                    <label htmlFor="inputNome">Nome</label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputNome"
                        placeholder="Nome"
                        value={user.firstName}
                        onChange={(e) => {set('firstName', e.target.value)}}
                        required
                        minLength={3}
                        maxLength={60}
                    />
                    <div className="invalid-feedback">
                        Informe um nome com no mínimo 3 caracteres
                    </div>
                </div>
                <div className="col-md-8 mb-3">
                    <label htmlFor="inputSobrenome">
                        Sobrenome
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputSobrenome"
                        placeholder="Sobrenome"
                        value={user.lastName}
                        onChange={(e) => {set('lastName', e.target.value)}}
                        required
                        minLength={3}
                        maxLength={60}
                    />
                    <div className="invalid-feedback">
                        Informe um sobrenome com no mínimo 3 caracteres
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="inputEmail">
                        Email
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="inputEmail"
                        placeholder="Email"
                        value={user.email}
                        onChange={(e) => {set('email', e.target.value)}}
                        required
                        minLength={3}
                        maxLength={60}
                        pattern="^[^@]+@[^@]+\.[^@]+$"
                    />
                    <div className="invalid-feedback">
                        Informe um email válido
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="inputPassword">
                        Senha
                    </label>
                    <input
                        type="password"
                        className="form-control"
                        id="inputPassword"
                        placeholder="Informe a nova senha"
                        value={user.password}
                        onChange={(e) => {set('password', e.target.value)}}
                        minLength={6}
                        maxLength={30}
                    />
                    <div className="invalid-feedback">
                        Informe um senha com no mínimo 6 caracteres
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="col-md-12 action-buttons">
                    <button onClick={cancelForm} className="btn mr-2">
                        Cancelar
                    </button>
                    <button type="submit" className="save-button">
                        Salvar
                        <i className="fas fa-check fa-sm ml-2" />
                    </button>
                </div>
            </div>
        </form>
    )
}

export default EditUser
